import { connect } from 'react-redux';
import { compose } from 'redux';

import withReducer from '@Hooks/withReducer';
import { open as openHeatmapIndicator, fullScreenMode as heatmapFullScreenModeIndicator } from '@Pages/Heatmap/selectors';
import { setDrawingFromResults } from '@Containers/ResultsFilters/ResultsFiltersComponents/StructureFilter/StructureFilterActions';
import openCloseResultsFiltersHOC from './OpenCloseResultsFiltersHOC';
import ResultsFilters from './ResultsFilters';
import resultsFiltersReducer from './ResultsFiltersReducer';
import { resultsFiltersReducerKey } from './ResultsFiltersConstants';
import { open } from './ResultsFiltersSelectors';
import { setOpenFilters } from './ResultsFiltersActions';

function mapStateToProps(state) {
  return {
    open: open(state),
    openHeatmapIndicator: openHeatmapIndicator(state),
    heatmapFullScreenModeIndicator: heatmapFullScreenModeIndicator(state),
  };
}

const mapDispatchToProps = {
  setOpenFilters,
  setDrawingFromResults,
};

export default compose(
  withReducer(resultsFiltersReducerKey, resultsFiltersReducer, true),
  connect(mapStateToProps, mapDispatchToProps),
  openCloseResultsFiltersHOC
)(ResultsFilters);
